import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";

const tableConfig: FinalTableConfig = {
  index: null,
  actions: [
    
  ],
  rowActions: [
    
  ],
  rowConfiguration: {
    class: (element: any) => {
      return null;
    },
  },
  columns: [
    {
      name: "id",
      label: "#",
      key: "id",
      type: "number",
      show: true,
      allowOrder: true,
    },
    {
      name: "producer",
      label: "producer",
      key: "emitter.user.name" ,
      type: "string",
      show: true,
      allowOrder: true,
    },
    {
      name: "order_amount",
      label: "order_amount",
      key: "concept.total_price" ,
      type: "currency",
      currency: "EUR",
      show: true,
      allowOrder: true,
    },
    {
      name: "commission_amount",
      label: "commission_amount",
      key: "concept.commission_amount" ,
      type: "currency",
      currency: "EUR",
      show: true,
      allowOrder: true,
    }
  
  ],
  pagination: {
    enabled: true,
    back: true,
  },
};
const getConfig: any = (functions: any) => {
  const {
    getFunction,
    indexFunction,
    initializeFunction,
    prepareRemoveFunction,
    importFunction,
    exportFunction,
    commerce
  } = functions;
  // tableConfig.actions[0].action = () => exportFunction();
  // tableConfig.actions[1].action = () => importFunction();
  // tableConfig.actions[2].action = () => initializeFunction();
  tableConfig.index = () => indexFunction();
  // tableConfig.rowActions[0].action = (id: any) => getFunction(id);
  // tableConfig.rowActions[1].action = (id: any) => prepareRemoveFunction(id);
  // tableConfig.columns[4].currency = commerce ? commerce.currency : 'EUR';

  return tableConfig;
};
export default getConfig;
